import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetProductsV2ByToken($token: String!, $filter: AutoFilledFilterFindManyproductV2Input) {
    getProductsV2ByToken(token: $token, filter: $filter) {
      items {
        name
        description
        provider
        companyId
        defaultPrice
        currency
        unitLabel
        _id
        updatedAt
        createdAt
        group
        status
        prices {
          _id
          description
          direction
          flatFee
          months
          name
          years
          pricingModel
        }
      }
    }
  }
`;
